import { render } from "./RestaurantEditIngredients.vue?vue&type=template&id=d71e210c"
import script from "./RestaurantEditIngredients.vue?vue&type=script&lang=js"
export * from "./RestaurantEditIngredients.vue?vue&type=script&lang=js"

import "./RestaurantEditIngredients.vue?vue&type=style&index=0&id=d71e210c&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__